import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=5f078932"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/home/forge/meidenvanholland.nl/components/breadcrumbs.vue').default,Thumb: require('/home/forge/meidenvanholland.nl/components/thumb.vue').default,Error: require('/home/forge/meidenvanholland.nl/components/error.vue').default})
